import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/creators/{creatorId}/payment-methods/default']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getDefaultPaymentMethod = async ({ creatorId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/creators/{creatorId}/payment-methods/default', { creatorId });
  const data = await noodleApiClient.get(path);
  return data.data;
};

export default getDefaultPaymentMethod;
